<template>
    <div class="collection-filter">
        <DCol>
            <DRow
                class="mb-3"
                align-vertical="end"
            >
                <DCol sm="2">
                    <DInput
                        id="invoice-id"
                        :label="__('tools.collection.filters.invoiceId')"
                        class="mb-0"
                        :value="invoiceId"
                        @input="$emit('update:invoiceId', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol sm="2">
                    <DInput
                        id="customer-id"
                        :label="__('tools.collection.filters.customerId')"
                        class="mb-0"
                        :value="customerId"
                        @input="$emit('update:customerId', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol sm="2">
                    <DInput
                        id="company-or-customer-name"
                        :label="__('tools.collection.filters.customerSearch')"
                        class="mb-0"
                        :value="customerSearch"
                        @input="$emit('update:customerSearch', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol sm="2">
                    <DSelect
                        id="invoice-price-operator"
                        :label="__('tools.collection.filters.invoice_price_operator')"
                        :options="invoicePriceValues"
                        class="mb-0"
                        :model-value="invoicePriceOperator"
                        @update:value="$emit('update:invoicePriceOperator', $event)"
                    />
                </DCol>
                <DCol sm="2">
                    <DInput
                        id="invoice-price"
                        type="number"
                        :label="__('tools.collection.filters.amount')"
                        class="mb-0"
                        :value="invoicePrice"
                        @input="$emit('update:invoicePrice', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol sm="2">
                    <DSelect
                        id="currency_code"
                        :model-value="currency"
                        :label="__('tools.collection.filters.currency')"
                        :options="currencyCodes"
                        add-input-classes="bg-light"
                        @update:value="$emit('update:currency', $event)"
                    />
                </DCol>
                <DCol
                    v-if="brands.length > 0"
                    sm="2"
                >
                    <DMultiSelect
                        id="brand"
                        :label="__('tools.collection.filters.brand')"
                        :options="brandOptions"
                        :search="true"
                        :selection="true"
                        selection-type="text"
                        class="mb-0"
                        @update="$emit('update:selectedBrands', $event)"
                    />
                </DCol>
                <DCol
                    sm="2"
                >
                    <DFormCheck
                        id="exclude-invoices-with-open-incidents"
                        :label="__('tools.collection.filters.exclude_invoices_with_open_incidents')"
                        class="mb-0"
                        :model-value="Boolean(excludeInvoicesWithOpenIncidents)"
                        @update:modelValue="$emit('update:excludeInvoicesWithOpenIncidents', $event)"
                    />
                </DCol>
            </DRow>
            <DRow
                class="mb-3"
                align-vertical="end"
            >
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        id="filter-apply"
                        :label="__('tools.collection.filters.filter')"
                        @click="$emit('filter')"
                    />
                    <DButton
                        id="filter-reset"
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
    </div>
</template>

<script>
export default {
    name: 'CollectionFilter',
    props: {
        invoiceId: {
            type: String,
            default: null
        },
        customerId: {
            type: String,
            default: null
        },
        customerSearch: {
            type: String,
            default: null
        },
        invoicePrice: {
            type: String,
            default: null
        },
        selectedBrands: {
            type: Array,
            default: () => { return [] }
        },
        invoicePriceOperator: {
            type: String,
            default: 'greater'
        },
        brands: {
            type: Array,
            default: () => { return [] }
        },
        excludeInvoicesWithOpenIncidents: {
            type: Boolean,
            default: false,
        },
        currency: {
            type: String,
            default: null
        },
        currencyCodes: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: [
        'update:invoiceId',
        'update:customerId',
        'update:customerSearch',
        'update:invoicePriceOperator',
        'update:invoicePrice',
        'update:selectedBrands',
        'update:excludeInvoicesWithOpenIncidents',
        'update:currency',
        'filter'
    ],
    computed: {
        brandOptions () {
            // CMultiSelect reads the selection off the options rather than from a prop, and
            // `selected: false` is what makes it drop an option again — without it the reset button
            // clears the filter but leaves the brand shown as selected.
            return this.brands.map((item) => {
                return {
                    value: item.value,
                    text: item.label,
                    selected: this.selectedBrands.some((value) => String(value) === String(item.value))
                }
            })
        },
        invoicePriceValues () {
            return [
                {
                    value: 'less',
                    label: this.__('tools.collection.invoice_price_operators.less')
                },
                {
                    value: 'greater',
                    label: this.__('tools.collection.invoice_price_operators.greater')
                }
            ]
        }
    },
    methods: {
        resetFilters () {
            this.$emit('update:invoiceId', null)
            this.$emit('update:customerId', null)
            this.$emit('update:customerSearch', null)
            this.$emit('update:invoicePrice', null)
            this.$emit('update:invoicePriceOperator', 'greater')
            this.$emit('update:selectedBrands', [])
            this.$emit('update:excludeInvoicesWithOpenIncidents', false)
            this.$emit('update:currency', null)
            this.$emit('filter')
        }
    }
}
</script>
